<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      客户超期管理
    </div>
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="分销商名称" prop="agentName">
          <el-input v-model.trim="searchForm.agentName" placeholder="请输入分销商名称" clearable />
        </el-form-item>
        <el-form-item label="客户名称" prop="integratorName">
          <el-input v-model.trim="searchForm.integratorName" placeholder="请输入客户名称" clearable />
        </el-form-item>
        <el-form-item label="是否超期" prop="overdueFlag">
          <el-select v-model="searchForm.overdueFlag" placeholder="全部" clearable>
            <el-option label="未超期" :value="0" />
            <el-option label="已超期" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="handleSearch">
            搜索
          </el-button>
          <el-button @click="resetSearch">
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="agentName" label="分销商名称" align="left" min-width="180" />
          <el-table-column prop="integratorName" label="客户名称" align="left" min-width="180" />
          <el-table-column label="是否超期" align="left" width="120">
            <template v-slot="{ row }">
              <el-tag :type="Number(row.overdueFlag) === 1 ? 'danger' : 'success'" size="mini">
                {{ Number(row.overdueFlag) === 1 ? '已超期' : '未超期' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="updateUser" label="维护人" align="left" min-width="120" />
          <el-table-column prop="updateTime" label="维护时间" align="left" min-width="170" />
          <el-table-column label="操作" align="left" width="120" fixed="right">
            <template v-slot="{ row }">
              <el-button type="text" @click="openEdit(row)">
                编辑
              </el-button>
              <el-button type="text" @click="remove(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.pageIndex"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <el-dialog title="编辑客户超期状态" :visible.sync="editVisible" width="420px" @close="resetEditForm">
        <el-form ref="editForm" :model="editForm" label-width="100px">
          <el-form-item label="分销商名称">
            <span>{{ editForm.agentName }}</span>
          </el-form-item>
          <el-form-item label="首级名称">
            <span>{{ editForm.integratorName }}</span>
          </el-form-item>
          <el-form-item label="是否超期" prop="overdueFlag" required>
            <el-select v-model="editForm.overdueFlag" placeholder="请选择">
              <el-option label="未超期" :value="0" />
              <el-option label="已超期" :value="1" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取消</el-button>
          <el-button type="primary" :loading="editLoading" @click="submitEdit">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { deleteAgentOverdue, getAgentOverdueList, updateOverdueFlag } from '@/API/agentOverdue';

export default {
  data () {
    return {
      searchForm: {
        agentName: '',
        integratorName: '',
        overdueFlag: null
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      editVisible: false,
      editLoading: false,
      editForm: this.createEditForm()
    };
  },
  methods: {
    createEditForm () {
      return {
        id: null,
        agentName: '',
        integratorName: '',
        overdueFlag: null
      };
    },
    requestContext () {
      const user = this.$store.state.user || {};
      const distributorType = Number(user.isDistributors);
      return {
        currentAgentId: user.userId || '',
        agentUser: distributorType === 1 || distributorType === 2
      };
    },
    handleSearch () {
      this.page.pageIndex = 1;
      this.search();
    },
    search () {
      this.tableLoading = true;
      getAgentOverdueList({
        ...this.searchForm,
        ...this.requestContext(),
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    resetSearch () {
      this.$refs.searchForm.resetFields();
      this.page.pageIndex = 1;
      this.search();
    },
    handleSizeChange () {
      this.page.pageIndex = 1;
      this.search();
    },
    handleCurrentChange () {
      this.search();
    },
    openEdit (row) {
      this.editForm = {
        id: row.id,
        agentName: row.agentName,
        integratorName: row.integratorName,
        overdueFlag: Number(row.overdueFlag)
      };
      this.editVisible = true;
    },
    resetEditForm () {
      this.editLoading = false;
      this.editForm = this.createEditForm();
    },
    submitEdit () {
      if (this.editForm.overdueFlag === null) {
        this.$message.warning('请选择是否超期');
        return;
      }
      const user = this.$store.state.user || {};
      this.editLoading = true;
      updateOverdueFlag({
        ...this.requestContext(),
        id: this.editForm.id,
        overdueFlag: this.editForm.overdueFlag,
        updateUser: user.userName || user.userId || ''
      }).then((res) => {
        if (res.data.status === '200') {
          this.$message.success('更新成功');
          this.editVisible = false;
          this.search();
        }
      }).finally(() => {
        this.editLoading = false;
      });
    },
    remove (row) {
      this.$confirm('确定删除该客户超期记录吗？', '删除确认', {
        type: 'warning'
      }).then(() => {
        const user = this.$store.state.user || {};
        return deleteAgentOverdue({
          ...this.requestContext(),
          id: row.id,
          updateUser: user.userName || user.userId || ''
        });
      }).then((res) => {
        if (res && res.data.status === '200') {
          this.$message.success('删除成功');
          this.search();
        }
      }).catch(() => {});
    }
  },
  mounted () {
    this.search();
  }
};
</script>
